import React from "react";
import Link from "gatsby-link";
import Container from "./container";
import SectionHeading from "./section-heading";

const HomepageInterests = props => (
  <div className="homepage-interests">
    <Container>
      <SectionHeading
        title="What piques our mind?"
        description="Ideas. Disruptive visions that can change the world for the better (even if it’s just the tiniest part of it). We are always on the lookout to partner with equals, with individuals who want to accelerate their business. Currently we are most inspired by topics such as Artificial Intelligence and its application in different areas of our life. But we do not limit our innovational hub to just one branch, we rather spread it across multiple different industries and try to make this world a better place for all its inhabitants."
      />

      <Link to="/about">
        <div className="button">
          Read More
        </div>
      </Link>
    </Container>
  </div>
);

export default HomepageInterests;



// WEBPACK FOOTER //
// ./src/components/homepage-interests.js